<template>
    <b-card no-body>
        <!-- <CallFilterDrawer ref="messaging_drawer"></CallFilterDrawer> -->
        <!-- <EditCallModal :update_status.sync="modals.update_status" v-on:closeModal="closeModal()" :status_data="status_data" :status_name="status_name"/> -->
        
        <EditCallModal :update_call.sync="modals.update_call" :callEdited="callEdited" v-on:closeModal="closeModal()" @getCall="getCall"/>
        <!-- HEADER -->
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6">
                    <b-row>
                        <!-- SEARCH INPUT -->
                        <b-col cols="12" md="6" class="d-md-flex">
                            <base-input
                            label="Search"
                            v-model="searchQuery"
                            v-on:input="debouncedHandler"
                            prepend-icon="fas fa-search"
                            placeholder="Search...(case-sensitive)"
                            >
                            </base-input>
                        </b-col>
                        <!-- FILTER BY STATUS -->
                        <b-col cols="12" md="6" class="d-md-flex">
                            <b-form-group label="Filter by Status">
                                 <el-select v-model="arrStatusFilter" multiple placeholder="Select" @change="filterByStatus($event)">
                                    <el-option
                                    v-for="status in statusOptions"
                                    :key="status.value"
                                    :label="status.label"
                                    :value="status.value">
                                    </el-option>
                                </el-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="6" class="d-flex align-items-center justify-content-md-end">
                    <b-button class="float-right px-3 py-2 mb-2 mb-md-0" variant="outline-secondary" disabled>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#73839C" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Filters
                    </b-button>
                </b-col>
            </b-row>
        </b-col>

        <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed="left"
                    height="500"
                ></el-table-column>
    
                <!-- CALL NAME/ID COLUMN -->
                <el-table-column
                    prop="lead_id"
                    label="Name/ID"
                    min-width="150"
                    sortable
                >
                    <template slot-scope="scope">
                        <router-link :to="'#'" class="name font-weight-500 mb-0">
                            {{ scope.row.lead_name }}
                        </router-link><br>
                         <p class="mb-0 bottom-line">{{ scope.row.lead_id }}</p>
                    </template>
                </el-table-column>
                
                <!-- CALL TYPE COLUMN -->
                <el-table-column
                    prop="call_type"
                    label="Call Type"
                    min-width="150"
                >
                <template slot-scope="scope">
                        <svg v-if="scope.row.call_type == 'OUTBOUND'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="mr-2" viewBox="0 0 24 24"><g fill="#000" fill-rule="evenodd" clip-rule="evenodd"><path d="M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.72 4.72a.75.75 0 1 1-1.06-1.06l4.72-4.72h-2.69a.75.75 0 0 1-.75-.75Z"/><path d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"/></g></svg>
                        <svg v-else-if="scope.row.call_type == 'INBOUND'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="mr-2" viewBox="0 0 24 24"><g fill="#000" fill-rule="evenodd" clip-rule="evenodd"><path d="M19.5 9.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l4.72-4.72a.75.75 0 1 1 1.06 1.06L16.06 9h2.69a.75.75 0 0 1 .75.75Z"/><path d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"/></g></svg>
                        {{ scope.row.call_type }}
                </template>
                </el-table-column>

                <!-- CALL STATUS COLUMN -->
                <el-table-column
                    prop="call_status"
                    label="Status"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.call_status }}</p></template>
                    </el-table-column>

                    <!-- CALL DATETIME COLUMN -->
                    <el-table-column
                        prop="minutes_call"
                        label="Date/Time"
                        min-width="180"
                    >
                    <template slot-scope="scope">
                        <!-- <p class="mb-0 top-line">{{ scope.row.call_date }}</p> -->
                        <p class="mb-0 top-line">{{ scope.row.start_at | dateFormatString }} ({{ getDay(scope.row.start_at) }})</p>
                        <p class="mb-0 bottom-line">{{ scope.row.start_at | timeFormatString }}</p>
                    </template>
                </el-table-column>
                
                <!-- CALL DURATION COLUMN -->
                <el-table-column
                    prop="group"
                    label="Duration"
                    min-width="150"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.minutes_call }} minutes</p>
                    </template>
                </el-table-column>

                <!-- CALL ASSINGN TO/HUB(TEAM) COLUMN -->
                <el-table-column
                    prop="group"
                    label="Assign To/HUB(Team)"
                    min-width="200"
                    sortable
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.user_name }}</p>
                        <span class="mb-0 bottom-line">{{ scope.row.hub_name }} </span>
                        <span class="mb-0 bottom-line">({{ scope.row.team_name }})</span>
                    </template>
                </el-table-column>

                <!-- CALL ACTION COLUMN -->
                <el-table-column
                    width="55"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown :tabindex="scope.row.id" class="py-2">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="editCall(scope.row)">
                                    <b-icon-telephone-fill></b-icon-telephone-fill>
                                    Edit
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="deleteCall(scope.row.call_id)">
                                    <span class="text-danger">
                                        <b-icon-trash></b-icon-trash>
                                        <span class="text-danger">Delete</span>
                                    </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

    </b-card>
</template>

<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import CallFilterDrawer from '@/views/Call/Drawer/CallFilter'
import EditCallModal from '@/views/Call/Modal/EditCallModal'

import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { EventBus } from "@/main";

export default {
    name: 'status-setting-table',
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        CallFilterDrawer,
        BasePagination,
        EditCallModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    props: {
        all_status:{

        }
    },
    data() {
        return {
            arrStatusFilter: [],
            modals: {
                update_status: false,
                update_call: false,
            },
            isTableLoading: false,
            propsToSearch:['lead_name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            statusOptions: [
                {
                    value: 'Scheduled',
                    label: 'Scheduled'
                },
                {
                    value: 'Completed',
                    label: 'Completed'
                },
                {
                    value: 'Canceled',
                    label: 'Canceled'
                },
                {
                    value: 'Postponed',
                    label: 'Postponed'
                },
                {
                    value: 'Missed',
                    label: 'Missed'
                },
            ],
            callEdited: {},
            allCallsData: [],
        }
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
        this.getCall()
        EventBus.$on('getnewcall', () => {
            this.getCall()
        });
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getCall(){
            this.allCallsData = []
            this.isTableLoading = true
            axios.get(services.lead + 'call', {headers: getHeader()})
                .then(res => {
                    this.isTableLoading = false
                    this.allCallsData.push(res.data.data)
                    this.tableData = res.data.data
                })
                .catch(e => {
                    this.isTableLoading = false
                    this.errorFunction(e)
                })
        },
        editCall(call){
            this.callEdited = call
            this.modals.update_call = true
        },
        deleteCall(call_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.lead + 'call/' + call_id, {headers: getHeader()})
                    .then(res => {
                        // this.getCall()
                            this.tableData.forEach((element,index) => {
                                if(element.call_id == call_id){
                                    this.tableData.splice(index,1);
                                }
                            });
                            this.notifySuccess('<b>Status </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                        
                    }
            })
        },
        closeModal(){
            if(this.status_data.status == ""){

            }
            this.modals.update_status = false
        },
        getNewCall(res){
            this.tableData.unshift(res)
        },
        dateTimeFormatString(value) {
            if (!value) {
            return ''; // Return an empty string or a default value if the input value is falsy
        }

        const dateObj = new Date(value);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = dateObj.toLocaleDateString(undefined, options);

        return formattedDate;
        },
        getDay(date){
            const thedate = new Date(date)
            const day = thedate.toLocaleString('en-US', { weekday: 'short' });
            return day;
        },
        filterByStatus(data){

            if(!data.length == 0){
                let filteredData = []
                this.isTableLoading = true
                this.tableData = []
                this.allCallsData[0].forEach(element => {
                    data.forEach(status => {
                        element.call_status === status ? filteredData.push(element) : ""
                    });
                });
                this.isTableLoading = false
                this.tableData = filteredData
            }else{
                this.tableData = this.allCallsData[0]
            }

        }
    }
}
</script>
